/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Signin2Inputs */

const he_ratelimit_signin2 = /** @type {(inputs: Ratelimit_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחבר למהירות מלאה`)
};

const en_ratelimit_signin2 = /** @type {(inputs: Ratelimit_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In for More Speed`)
};

/**
* | output |
* | --- |
* | "Sign In for More Speed" |
*
* @param {Ratelimit_Signin2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_signin2 = /** @type {((inputs?: Ratelimit_Signin2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Signin2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_signin2(inputs)
	return en_ratelimit_signin2(inputs)
});
export { ratelimit_signin2 as "rateLimit_signIn" }